import React, { Component } from 'react';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { NOTIFICATION_HUB_URL } from '../../utility/environment_config';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showNotificationBox, resetNotificationBox } from '../../redux/actions/notificationBoxActions';
import { updateInsideNotificationStripe, updateOutsideNotificationStripe } from '../../redux/actions/notificationStripeActions';
import { markAsRead } from '../../utility/commonFunctions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {}
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showNotificationBox,
    resetNotificationBox,
    updateInsideNotificationStripe,
    updateOutsideNotificationStripe
};

class NotificationHub extends Component {

    componentDidMount() {

        let hubUrl = NOTIFICATION_HUB_URL;

        const hubConnection = new HubConnectionBuilder()
            .withUrl(hubUrl)
            .withAutomaticReconnect()
            .build();

        if (hubConnection) {
            hubConnection.start()
                .then(result => {

                    hubConnection.on('ReceiveMessage', (message) => {
                        if (message != null) {
                            let notificationBox = {
                                show: true,
                                title: message.title,
                                className: message.class,
                                content: message.message,
                                isConfirmation: false,
                                callBackFunction: (response) => {
                                    if (response) {
                                        markAsRead(message.notificationID);
                                    } else {
                                        // markAsRead(message.notificationID)
                                    }
                                }
                            }
                            this.props.showNotificationBox(notificationBox);
                        }
                    });

                    hubConnection.on('ReceiveInsideNotificationStripeMessage', (message) => {
                        if (message != null) {
                            let body = {
                                message: message.message,
                                cssClass: message.class,
                                isActive: message.isActive ? true : false,
                                triggered: true
                            }
                            this.props.updateInsideNotificationStripe(body);
                        }
                    });

                    hubConnection.on('ReceiveOutsideNotificationStripeMessage', (message) => {
                        if (message != null) {
                            let body = {
                                message: message.message,
                                cssClass: message.class,
                                isActive: message.isActive ? true : false,
                                triggered: true
                            }
                            this.props.updateOutsideNotificationStripe(body);
                        }
                    });
                })
                .catch(() => console.log('Connection failed.'));
        }
    };

    render() {
        return (
            <div></div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationHub);
